import { useState } from "react";
import { useDispatch } from "react-redux";
import { openVideoPopup } from "../../../../Redux/Actions/PopupActions";

const SharedVideoDetails = ({ item }) => {
  const [showDescription, setShowDescription] = useState(false);
  const dispatch = useDispatch();

  const description = showDescription
    ? item?.shareMedia?.videoDescription
    : `${item?.shareMedia?.videoDescription.slice(0, 70)}`;

  return (
    <div className="row mg-top-10">
      <div className="col-lg-4">
        <video src={item?.thumbnailUrl} className="shared-video-preview" />
      </div>
      <div className="col-lg-8 pd-5">
        <p className="bold fs-18 mg-bottom-5">{item?.shareMedia?.videoTitle}</p>
        <p className="font-17 regular-2">
          {description}
          {item?.shareMedia?.videoDescription?.length > 70 && (
            <span
              className="color-main-blue cp bold"
              onClick={() => {
                setShowDescription(!showDescription);
              }}
            >
              {` Show ${showDescription ? "Less" : "More"}`}
            </span>
          )}
        </p>
        <button
          className="btn-back mg-top-10"
          onClick={() =>
            openVideoPopup(dispatch, {
              status: true,
              videoURL: item?.thumbnailUrl,
            })
          }
        >
          Watch Video
        </button>
      </div>
    </div>
  );
};

export default SharedVideoDetails;
